import { render, staticRenderFns } from "./ImportShowConfirmScreen.vue?vue&type=template&id=0c234454&scoped=true&"
import script from "./ImportShowConfirmScreen.vue?vue&type=script&lang=js&"
export * from "./ImportShowConfirmScreen.vue?vue&type=script&lang=js&"
import style0 from "./ImportShowConfirmScreen.vue?vue&type=style&index=0&id=0c234454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c234454",
  null
  
)

export default component.exports